import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import Collapsable from 'components/Pages/Wine/View/Common/Collapsable'
import KoefSelector from 'components/Pages/Wine/View/Main/Content/ColumnRight/NutritionDeclaration/KoefSelector'
import Table from 'components/Pages/Wine/View/Main/Content/ColumnRight/NutritionDeclaration/Table'
import { EmptyInfo } from 'components/Pages/Wine/View/Main/Content/ColumnLeft/_styles'
import { StyledLink } from 'components/Common/MasterComponents'
import styled from 'styled-components'
import useUserRole from 'utils/user/useUserRole'
import { useCapturedWine } from '../../../_methods/context'
import { useProduct } from 'components/Pages/Wine/View/Main/_methods'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const fields = [
  'carbohydrate',
  'energyKCal',
  'energyKJ',
  'fat',
  'protein',
  'salt',
  'saturates',
  'sugars',
]

const NutritionDeclaration = () => {
  const { t } = useTranslation()
  const product = useProduct()
  const { isAuthor, capturedWine, canEdit: canEditCtx } = useCapturedWine()
  const { isContent, isSuperAdmin } = useUserRole()
  const canEdit =
    canEditCtx !== undefined
      ? canEditCtx
      : isAuthor || isContent || isSuperAdmin

  const nutritionDeclaration = product?.wine?.nutritionDeclaration
  const isEmpty = fields.every(field => {
    const value = (nutritionDeclaration as any)?.[field]
    return value === undefined || value === null || value === 0
  })

  const [koef, setKoef] = useState(1)

  return (
    <Collapsable title={t('wine.view.nutritionDeclaration.title')}>
      {!isEmpty && (
        <Wrapper>
          <KoefSelector onChange={setKoef} bottleSize={product?.bottleSize} />
          <Table values={nutritionDeclaration} koef={koef} />
        </Wrapper>
      )}

      {isEmpty && canEdit && (
        <EmptyInfo>
          <Trans
            t={t}
            i18nKey='wine.view.noNutritionDeclaration'
            components={[
              <StyledLink
                key={0}
                to={`/acc/captured-wine/${capturedWine.id}/edit/general`}
              />,
            ]}
          />
        </EmptyInfo>
      )}

      {isEmpty && !canEdit && (
        <EmptyInfo>{t('capturedWine.view.noNutritionDeclaration')}</EmptyInfo>
      )}
    </Collapsable>
  )
}

export default NutritionDeclaration
